import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * PublicRoute - Wrapper component for public routes (login, register)
 * Redirects to dashboard if user is already authenticated
 * 
 * @param {ReactNode} children - Child components to render if not authenticated
 */
const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.user);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
